// extracted by mini-css-extract-plugin
export var container = "_da-0";
export var infoIcon = "_da-2";
export var titleRowCol = "_da-1";